import axiosServices from 'src/utils/axios';

export interface UserSummary {
  roleId: number;
  roleName: string | null;
  fullName: string | null;
  email: string | null;
  pharmacyId: number | null;
  avatarUrl: string | null;
  mustChangePassword: boolean;
}

export type ProfileData =
  | { available: false }
  | {
      available: true;
      name: string;
      lastName: string;
      documentNumber: string;
      email: string | null;
      phone: string | null;
      address: string | null;
      avatarUrl: string | null;
      branchName?: string | null;
    };

export const getMe = async (): Promise<UserSummary> => {
  const response = await axiosServices.get('/user/me');

  return response.data;
};

export const getProfile = async (): Promise<ProfileData> => {
  const response = await axiosServices.get('/user/profile');

  return response.data;
};

export const updateProfile = async (payload: { email: string; phone: string; address: string }): Promise<ProfileData> => {
  const response = await axiosServices.put('/user/profile', payload);

  return response.data;
};

export const changePassword = async (payload: { oldPassword: string; newPassword: string; newUsername?: string }) => {
  const response = await axiosServices.put('/user/change-password', payload);

  return response.data;
};

export const updateAvatar = async (file: File): Promise<{ avatarUrl: string | null }> => {
  const formData = new FormData();
  formData.append('avatar', file);

  const response = await axiosServices.put('/user/avatar', formData);

  return response.data;
};

export const deleteAvatar = async (): Promise<void> => {
  await axiosServices.delete('/user/avatar');
};
